export default {
  DisableOverlay: 'rfp-storelocator-disable-overlay',
  StoresFound: 'rfp-stores-found',
  StoresFoundInCurrentArea: 'rfp-stores-found-in-current-area',
};
